module.exports = __webpack_public_path__ + "img/cheap.5da923cb.png";